var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfileClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 1.66797H5.00016C4.0835 1.66797 3.3335 2.41797 3.3335 3.33464V16.668C3.3335 17.5846 4.0835 18.3346 5.00016 18.3346H15.0002C15.9168 18.3346 16.6668 17.5846 16.6668 16.668V3.33464C16.6668 2.41797 15.9168 1.66797 15.0002 1.66797ZM7.50016 3.33464H9.16683V7.5013L8.3335 6.8763L7.50016 7.5013V3.33464ZM5.00016 16.668H15.0002V3.33464H10.8335V10.8346L8.3335 8.95964L5.8335 10.8346V3.33464H5.00016V16.668Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileClass);
export default __webpack_public_path__ + "static/media/ic-profile-class.0952c912d8ba902ee50eb31d5facf483.svg";
export { ForwardRef as ReactComponent };